import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgMoon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M25.543 15.556a.875.875 0 0 0-.875-.218A9.633 9.633 0 0 1 12.66 3.328a.875.875 0 0 0-1.094-1.093A11.467 11.467 0 0 0 5.778 6.28a11.375 11.375 0 0 0 9.097 18.22c2.468.008 4.87-.795 6.838-2.284a11.467 11.467 0 0 0 4.047-5.787.874.874 0 0 0-.217-.873Zm-4.882 5.263A9.625 9.625 0 0 1 7.18 7.34a9.735 9.735 0 0 1 3.435-2.844 11.387 11.387 0 0 0 12.891 12.888 9.735 9.735 0 0 1-2.846 3.434Z" />
  </svg>
);
export default SvgMoon;
